(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function LogosFilters(elem) {
        Behaviors.init(LogosFilters, this, arguments);

        var $thisElem = this.$elem;

        // Logo Filters
        function Filters(paged, loadmore = '') {
            var loop = $thisElem.find('.OELogoFilters-loop'),
                category = $thisElem.find('.OELogoFilters-category.active').length > 0 ? $thisElem.find('.OELogoFilters-category.active').data('filter') : '',
                type = $thisElem.find('.OELogoFilters-type.active').length > 0 ? $thisElem.find('.OELogoFilters-type.active').data('filter') : '',
                defaultCategories = $thisElem.data('default-categories'),
                defaultTypes = $thisElem.data('default-types'),
                urlParameters = '';

            // Url parameters
            if (category.length > 0) {
                urlParameters += 'category=' + category;
            }

            if (type.length > 0) {
                urlParameters += urlParameters ? '&' : '';
                urlParameters += 'type=' + type;
            }

            urlParameters = urlParameters ? '?' + urlParameters : ' ';

            if (urlParameters.length > 1) {
                history.replaceState(undefined, undefined, urlParameters);
            } else {
                history.replaceState(undefined, undefined, '?');
            }

            $.ajax({
                url: wpAjaxUrl, // AJAX handler
                data: {
                    'action': 'logos_filters',
                    paged: paged,
                    category: category,
                    type: type,
                    defaultCategories: defaultCategories,
                    defaultTypes: defaultTypes
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('OE--loading');
                },
                success: function (data) {

                    if (loadmore !== '') {
                        loop.append(data);
                    } else {
                        loop.html(data);
                    }

                    var maxPages = parseInt($('.max-pages').text());

                    $('.max-pages').remove();

                    $thisElem.find('.OELogoFilters-load-more').data('paged', paged);
                    $thisElem.find('.OELogoFilters-load-more').data('max-pages', maxPages);

                    $thisElem.removeClass('OE--loading');

                    if (paged == maxPages || maxPages == 0) {
                        $thisElem.find('.OELogoFilters-load-more').parent().hide();
                    } else {
                        $thisElem.find('.OELogoFilters-load-more').parent().show();
                    }

                    if (category || type) {
                        $thisElem.find('.OE-clear-filters').addClass('OE-clear-filters--show');
                    } else {
                        $thisElem.find('.OE-clear-filters').removeClass('OE-clear-filters--show');
                    }

                }
            });
            return false;
        }

        // Load More
        $(document).on("click", '.OELogoFilters-load-more', function (e) {
            e.preventDefault();
            var $this = $(this),
                paged = $this.data('paged'),
                maxPages = $this.data('max-pages');

            if (paged < maxPages) {
                paged = paged + 1;
            }

            Filters(paged, true);
        });


        // Category Filter
        $thisElem.find('.OELogoFilters-category').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);

            if (!$this.hasClass('active')) {
                $thisElem.find('.OELogoFilters-category').removeClass('active');
                $this.addClass('active');
            }

            Filters(1);
        });

        // Type Filter
        $thisElem.find('.OELogoFilters-type').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);

            if (!$this.hasClass('active')) {
                $thisElem.find('.OELogoFilters-type').removeClass('active');
                $this.addClass('active');
            }

            Filters(1);
        });

        // Clear Filters
        $thisElem.find('.OE-clear-filters').on('click', function (e) {
            e.preventDefault();

            $thisElem.find('.OELogoFilters-category').removeClass('active');
            $thisElem.find('.OELogoFilters-type').removeClass('active');

            $thisElem.find('.OE-Dropdown-button-text--category').text($thisElem.find('.OE-Dropdown-button-text--category').data('default-label'));
            $thisElem.find('.OE-Dropdown-button-text--type').text($thisElem.find('.OE-Dropdown-button-text--type').data('default-label'));

            Filters(1);
        });
    }

    Behaviors.inherit(LogosFilters, Behaviors.Behavior);

    LogosFilters.QUERY = "[data-logos-filters]";

    Behaviors.register_behavior(LogosFilters);

    module.LogosFilters = LogosFilters;

    return module;

}(window.jQuery, window.Behaviors));